import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/qk.png'
import _imports_1 from '@/assets/zt_zanwushuju.png'
import _imports_2 from '../../assets/module_share_open.png'
import _imports_3 from '../../assets/lxhz_icon.png'


const _hoisted_1 = { style: {"margin-top":"0.7rem"} }
const _hoisted_2 = { class: "meaasgeTitle" }
const _hoisted_3 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_4 = { class: "meaasgeTitle_" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "meaasgeTitle_xttz_list"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "message-content" }
const _hoisted_9 = { class: "MTXL_time" }
const _hoisted_10 = { class: "MTXL_title" }
const _hoisted_11 = {
  key: 0,
  class: "link-container"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  style: {"width":"100%","height":"5rem"}
}
const _hoisted_14 = {
  key: 1,
  class: "meaasgeTitle_dz_list"
}
const _hoisted_15 = { class: "MT_dz_list" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "MT_dz_list_name" }
const _hoisted_18 = { class: "MT_dz_list_time" }
const _hoisted_19 = { class: "MT_dz_list_z" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  style: {"width":"100%","height":"5rem"}
}
const _hoisted_22 = {
  key: 2,
  class: "meaasgeTitle_sc_list"
}
const _hoisted_23 = { class: "MT_dz_list" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "MT_dz_list_name" }
const _hoisted_26 = { class: "MT_dz_list_time" }
const _hoisted_27 = { class: "MT_dz_list_z" }
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  style: {"width":"100%","height":"5rem"}
}
const _hoisted_30 = {
  key: 3,
  class: "meaasgeTitle_fs_list"
}
const _hoisted_31 = { class: "MT_dz_list" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "MT_dz_list_name" }
const _hoisted_34 = { class: "MT_dz_list_time" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 1,
  style: {"width":"100%","height":"5rem"}
}
const _hoisted_37 = { class: "tac" }
const _hoisted_38 = { class: "zf_body" }
const _hoisted_39 = { class: "zf_body_top" }
const _hoisted_40 = { class: "zf_b_M" }
const _hoisted_41 = { class: "zf_b_M_number" }
const _hoisted_42 = { class: "zf_fs_body" }
const _hoisted_43 = { class: "zf_fs_list" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["src"]
const _hoisted_46 = {
  key: 0,
  class: "zf_fs_icon",
  src: _imports_3,
  alt: ""
}
const _hoisted_47 = { class: "zf_fs_b" }
const _hoisted_48 = { style: {"text-align":"center","padding-top":"5px","font-size":"20px"} }
const _hoisted_49 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_50 = { style: {"text-align":"center"} }
const _hoisted_51 = ["innerHTML"]

import { onMounted, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Axios } from "@/assets/js/ls_com_axios.js";
import { ElMessage, ElLoading } from "element-plus";
import { useStore } from "vuex";
import DetailsOfWorks from "@/views/ShadowUser/components/DetailsOfWorks.vue";
import TwoDimensionalCode from "@/views/ShadowComposer/components/TwoDimensionalCode.vue";
import com_date from "@/assets/js/common.js";
import { nextTick } from "process";

export default /*@__PURE__*/_defineComponent({
  __name: 'MessageBarList',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const TwoDimensionalCodeRef = ref<any>();
const CloseQrCode1 = () => { };
const DetailsOfWorksRef = ref();
const DetailsOfWorksClick = (item) => {
  DetailsOfWorksRef.value.init(item.id);
};
const detailLinks = ref({
  material_order: { path: "/myOrder" },
  material_order1: { path: "/myOrder" },
  material_order2: { path: "/onSaleMaterial" },
  material_order3: { path: "/requirementPublish" },
  material_order4: { path: "/ShadowBusinessList" },
  material_order5: { path: "/requirementPublish", query: { ccNum: 2 } },
  material_order6: { path: "/requirementPublish" },
  material_order7: { path: "/requirementPublish" },
  need_publish: { path: "/requirementPublish" },
  need_signUp: { path: "/requirementPublish", query: { state: "first1" } },
  need_signBill: { path: "/requirementPublish", query: { state: "first" } },
  material_audit_s: { path: "/onSaleMaterial" },
  material_audit_f: { path: "/newTrialMaterial" },
  need_signRefuse: {
    path: "/requirementPublish",
    query: { state: "four" },
  },
  need_choice: {
    path: "/requirementManagement",
    query: { state: "first" },
  },
  need_pay_A: { path: "/requirementPublish", query: { state: "first" } },
  need_pay_B: {
    path: "/requirementManagement",
    query: { state: "second" },
  },
  need_settlement: {
    path: "/requirementManagement",
    query: { state: "four" },
  },
  need_refundSuccess: {
    path: "/requirementPublish",
    query: { state: "four3" },
  },
  need_refundFailed: {
    path: "/requirementPublish",
    query: { state: "four3" },
  },
  need_confirm: {
    path: "/requirementPublish",
    query: { state: "second" },
  },
  need_finish: {
    path: "/requirementPublish",
    query: { state: "second" },
  },
  work_like: {
    path: "/MessageBarList",
    query: { type: "1" },
  },
  work_favorite: {
    path: "/MessageBarList",
    query: { type: "2" },
  },
  follow: {
    path: "/MessageBarList",
    query: { type: "3" },
  },
  material_collect: {
    path: "/ShadowMaterialVideoParticulars",
    query: { id: "2" },
  },
  system_notice: {
    path: false,
  },
});

document.title = "标识山西-系统通知";
let pageDef = ref({
  pageNum: 1,
  pageSize: 5,
  total: 0,
});
let show = ref(false);
let showHtml = ref("<p></p>");
let showTitle = ref(null);
const init = () => {
  if (route.query.type) {
    nextTick(() => {
      meaasgeTitle_list.value[route.query.type].checked = true;
      meaasgeTitleNavClick(
        route.query.type / 1,
        meaasgeTitle_list.value[route.query.type]
      );
    });
  }
};
init();
const page = pageDef;
const HRU_list_qbyd = function () {
  // alert("全部已读待完成");
  Axios("post", `/system/notice/front/read`, {}, false, (res) => {
    // store.commit("SetSystemMessages", arr);
    getList();
    getList1(1);
    getList1(2);
    getList2();
    ElMessage.success("全部已读成功");
  });
};
const meaasgeTitle_list = ref([
  {
    img: require("../../assets/MessageBarList_xttz.png"),
    title: "系统通知",
    NumberX: "",
    value: 0,
    checked: true,
    MTNtitle: "xttz",
  },
  {
    img: require("../../assets/MessageBarList_dz.png"),
    title: "点赞",
    NumberX: "0",
    value: 0,
    checked: false,
    MTNtitle: "dz",
  },
  {
    img: require("../../assets/MessageBarList_sc.png"),
    title: "收藏",
    NumberX: "",
    value: 0,
    checked: false,
    MTNtitle: "sc",
  },
  {
    img: require("../../assets/MessageBarList_fs.png"),
    title: "粉丝",
    NumberX: "",
    value: 0,
    checked: false,
    MTNtitle: "fs",
  },
]);
const meaasgeTitle_list_xttz = ref([]);
const meaasgeTitle_list_dz = ref([
  // {
  //   headPortrait_img: require("../../assets/MessageBarList_fs.png"),
  //   userName: "吴洁丽",
  //   time: "2023-05-31 17:29",
  //   dz_number: 3,
  //   worksName: "大漠以北",
  //   worksImg: require("../../assets/LS1.png"),
  //   dz_imgList: [
  //     require("../../assets/MessageBarList_xttz.png"),
  //     require("../../assets/MessageBarList_xttz.png"),
  //     require("../../assets/MessageBarList_xttz.png"),
  //   ],
  // },
  // {
  //   headPortrait_img: require("../../assets/MessageBarList_fs.png"),
  //   userName: "吴洁丽2",
  //   time: "2023-05-31 17:29",
  //   dz_number: 0,
  //   worksName: "大漠以北",
  //   worksImg: require("../../assets/LS1.png"),
  // },
]);
const meaasgeTitle_list_sc = ref([
  {
    headPortrait_img: require("../../assets/MessageBarList_fs.png"),
    userName: "吴洁丽",
    time: "2023-05-31 17:29",
    dz_number: 3,
    worksName: "大漠以北",
    worksImg: require("../../assets/LS1.png"),
    dz_imgList: [
      require("../../assets/MessageBarList_xttz.png"),
      require("../../assets/MessageBarList_xttz.png"),
      require("../../assets/MessageBarList_xttz.png"),
    ],
  },
  {
    headPortrait_img: require("../../assets/MessageBarList_fs.png"),
    userName: "吴洁丽2",
    time: "2023-05-31 17:29",
    dz_number: 0,
    worksName: "大漠以北",
    worksImg: require("../../assets/LS1.png"),
  },
]);
const MTXL_titleindentID = function (index) {
  alert("模拟获取订单ID : " + index.indentID);
};
const composer = function (index) {
  router.push({
    path: "/ShadowComposerHomepage",
    query: { id: index.memberId },
  });
};
const loading = ref();
const meaasgeTitleNavClick = function (index, item) {
  loading.value = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  page.value.pageNum = 1;
  page.value.total = 1;

  for (let i = 0; i < meaasgeTitle_list.value.length; i++) {
    meaasgeTitle_list.value[i].checked = i === index;
    if (i === index) {
      meaasgeTitleNavNumber.value = item.MTNtitle;
      if (i === 0) {
        getList();
      } else if (i === 1 || i === 2) {
        getList1(i);
      } else {
        getList2();
      }
    }
  }
};

const initNum = () => {
  let type = router.currentRoute.value.query.type;
  type ? meaasgeTitleNavClick(type, meaasgeTitle_list.value[type]) : "";

  Axios("GET", "/system/notice/front/noread", {}, false, function (res) {
    meaasgeTitle_list.value[0].value = res.data.data;
    // console.log("111111", res.data.data);
    // getList();
  });

  Axios("GET", "/system/notice/front/noread-new", {}, false, function (res) {
    // meaasgeTitle_list.value[0].value = res.data.data;
    // console.log("resresresres", res.data.data);
    if (res.data.data.length) {
      meaasgeTitle_list.value[2].value = 0;
      res.data.data.forEach((e: any) => {
        if (e.code === "work_favorite" || e.code === "material_collect") {
          // 在累加前检查是否有值
          meaasgeTitle_list.value[2].value += e.count;
        }
        if (e.code === "work_like") {
          meaasgeTitle_list.value[1].value = e.count;
        }
        if (e.code === "follow") {
          meaasgeTitle_list.value[3].value = e.count;
        }
      });
    } else {
      meaasgeTitle_list.value.forEach((e) => {
        e.value = 0;
      });
    }
    loading.value ? loading.value.close() : "";
  });
};
initNum();
const goToDetail = (path: any, query = {}, item: any) => {
  let arr = [...store.state.SystemMessages];
  console.log(path);

  function removeObjectById(arr: any, id: any) {
    return arr.filter((obj: any) => obj.noticeId !== id);
  }

  Axios(
    "post",
    `/system/notice/front/one-read/${item.noticeId}`,
    {},
    false,
    function (res: any) {
      store.commit("SetSystemMessages", removeObjectById(arr, item.noticeId));
      if (!path) {
        showTitle.value = item.noticeTitle;
        showHtml.value = item.noticeContent;
        show.value = true;
        loading.value && loading.value.close();
        initNum();
        return;
      }
      if (item.code === "material_collect") {
        const extendsData = JSON.parse(item.extendsData);
        let url = "";

        switch (extendsData.materialType) {
          case 2:
            url = "/ShadowMaterialVideoParticulars";
            break;
          case 1:
            url = "/ShadowMaterialVideoMusic";
            break;
          case 0:
            url = "/ShadowMaterialVideoImage";
            break;
          default:
            // Handle default case
            break;
        }

        if (url != "/MessageBarList") {
          router.push({
            path: url,
            query: {
              id: extendsData.id,
            },
          });
        }
      } else if (item.code === "work_like" || item.code === "work_favorite") {
        const extendsData = JSON.parse(item.extendsData);
        DetailsOfWorksClick(extendsData);
      } else if (path == "/MessageBarList") {
        meaasgeTitle_list.value[query.type].checked = true;
        meaasgeTitleNavClick(
          query.type / 1,
          meaasgeTitle_list.value[query.type]
        );
      } else {
        router.push({
          path,
          query,
        });
      }
      initNum();
      loading.value && loading.value.close();
    }
  );
};

const meaasgeTitleNavNumber = ref("xttz");

const getList = () => {
  Axios(
    "GET",
    "/system/notice/front/list",
    {
      pageNum: page.value.pageNum,
      pageSize: page.value.pageSize,
      orderByColumn: "createTime",
      isAsc: "desc",
      // NoticeType: 3,
      // code: 'material_order,material_seller,need_refundSuccess,need_publish,need_signUp,need_choice,need_signBill,need_pay'
    },
    false,
    function (res) {
      res.data.rows.forEach((e) => {
        switch (e.code) {
          case "need_publish":
          case "material_order3":
          case "material_order5":
          case "material_order6":
          case "material_order7":
          case "need_signUp":
          case "need_signBill":
          case "need_signRefuse":
          case "need_pay_A":
          case "need_refundSuccess":
          case "need_refundFailed":
          case "need_confirm":
          case "need_finish":
          case "need_choice":
          case "need_pay_B":
          case "material_audit_s":
          case "material_audit_f":
          case "need_settlement":
            e.noticeTitle = e.noticeContent;
            break;
          case "work_like":
          case "work_favorite":
          case "follow":
            e.avatar1 = e.avatar;
            e.nickName1 = e.nickName;
            e.noticeContent = e.noticeContent || e.noticeTitle;
            break;
          case "material_collect":
            e.avatar1 = e.avatar;
            e.nickName1 = e.nickName;
            // e.noticeContent = e.noticeTitle;
            break;
          default:
            break;
        }
      });
      meaasgeTitle_list_xttz.value = res.data.rows;
      page.value.total = res.data.total;
      loading.value ? loading.value.close() : "";
    }
  );
};
const getList1 = (val) => {
  Axios(
    "GET",
    "/system/notice/front/list",
    {
      pageSize: page.value.pageSize,
      pageNum: page.value.pageNum,
      code: val == 2 ? "material_collect,work_favorite" : "work_like",
      type: val,
      isAsc: "desc",
      orderByColumn: "createTime",
    },
    false,
    function (res) {
      meaasgeTitle_list_dz.value = [];
      meaasgeTitle_list_dz.value = res.data.rows;
      page.value.total = res.data.total;
      loading.value ? loading.value.close() : "";
    }
  );
};
const getList2 = () => {
  let obj = { ...page.value };
  obj.orderByColumn = "followTime";
  obj.isAsc = "desc";
  obj.followId = JSON.parse(localStorage.getItem("userList")).memberId;
  Axios("GET", "/member/member-follow/list", obj, false, function (res) {
    meaasgeTitle_list_sc.value = res.data.rows;
    page.value.total = res.data.total;
    loading.value ? loading.value.close() : "";
  });
};
getList();
const typeT = () => {
  if (meaasgeTitleNavNumber.value === "xttz") {
    getList();
  } else if (meaasgeTitleNavNumber.value === "dz") {
    getList1(1);
  } else if (meaasgeTitleNavNumber.value === "sc") {
    getList1(2);
  } else {
    // getList();
    getList2();
  }
};
// 联系
const PartnersMobileNumber = ref(false);
const PartnersMobileNumber1 = ref();
let Contact = function (index) {
  Axios(
    "get",
    "/member/contacts/phone/" + index,
    {},
    false,
    function (res) {
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.msg;
      console.log("PartnersMobileNumber1.value ", PartnersMobileNumber1.value);
      console.log("PartnersMobileNumber1.value ", PartnersMobileNumber.value);
    },
    function (res) {
      ElMessage({
        showClose: true,
        message: res.data.msg,
        type: "warning",
      });
      console.log(res.data.data);

      getMoney(index);
    }
  );
};
let moenyNumber = ref(0);
let payment = ref(false);
let paymentTL_click = function (index) {
  for (let i = 0; i < paymentTypeList.value.length; i++) {
    if (index == paymentTypeList.value[i]) {
      paymentTypeList.value[i].checked = true;
    } else {
      paymentTypeList.value[i].checked = false;
    }
  }
};
// 支付类型列表
let paymentTypeList = ref([
  // {
  //   title: "我的账户",
  //   img: require("../../assets/lxhz_pb.png"),
  //   checked: true,
  // },
  {
    title: "微信",
    img: require("@/assets/lxhz_wx.png"),
    checked: true,
  },
  {
    title: "支付宝",
    img: require("@/assets/lxhz_zfb.png"),
    checked: false,
  },
]);
let obj = ref({});
let getMoney = function (index) {
  Axios("get", "/member/contacts/pay-amount", {}, false, function (res) {
    moenyNumber.value = res.data.msg;
    obj.value = {};
    obj.value = index;
    payment.value = true;
  });
};
// 支付获取联系方式
let get_sjh = function (obj) {
  let index = obj;
  Axios(
    "POST",
    "/member/contacts?memberId=" + index,
    {},
    false,
    function (res) {
      console.log(res.data);
    },
    function (res) {
      Axios(
        "POST",
        `/member/contacts/create-order/${index}`,
        {},
        false,
        function (res) {
          console.log();

          // console.log(res.data.data);
          TwoDimensionalCodeRef.value.init(
            res.data.data.qrcode,
            res.data.data.sceneId,
            index
          );
        },
        function (res) {
          console.log(res.data);
        }
      );
    }
  );
};
const CloseQrCode = (e) => {
  payment.value = false;
  Axios(
    "get",
    "/member/contacts/phone/" + e,
    {},
    false,
    function (res) {
      // res;
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.msg;
      // PartnersMobileNumber1.value = res.data.data.info.partyBContactInfo;
    },
    function (res) {
      console.log("没购买");
    }
  );
};
const currentChange = (val) => {
  loading.value = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  typeT();
};
// 在页面加载时和页面刷新后从本地存储中获取 messageCount 的值
onMounted(() => {
  const storedValue = localStorage.getItem("messageCount");
  if (storedValue !== null) {
    messageCount.value = parseInt(storedValue);
  }
});
const messageCount = ref(0);
// 监听 store.state.SystemMessages 变化
watch(
  () => store.state.SystemMessages,
  (newValue, oldValue) => {
    // 将数据存储到本地存储
    localStorage.setItem("systemMessages", JSON.stringify(newValue));

    // 调用方法，传入新旧值
    checkSystemMessages(newValue, oldValue);
  }
);

// 定义检查系统消息的方法
function checkSystemMessages(newValue, oldValue) {
  // 调用相应的方法
  function findDifference(arr1, arr2) {
    const noticeIds1 = arr1.map((item) => item.noticeId);
    const noticeIds2 = arr2.map((item) => item.noticeId);

    const uniqueToArr1 = noticeIds1.filter((id) => !noticeIds2.includes(id));
    const uniqueToArr2 = noticeIds2.filter((id) => !noticeIds1.includes(id));

    return {
      uniqueToArr1: uniqueToArr1,
      uniqueToArr2: uniqueToArr2,
    };
  }

  // 深度比较对象内容
  if (oldValue && JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
    // 在这里调用你的方法

    setTimeout(function () {
      initNum();
    }, 2000);
    let diff = findDifference(oldValue, newValue);
    // 将状态置为0
    meaasgeTitle_list_xttz.value.forEach((e) => {
      console.log(diff.uniqueToArr1, e.noticeId);
      if (diff.uniqueToArr1.includes(e.noticeId)) {
        e.status = 0;
      }
    });
    if (messageCount.value) messageCount.value--;
    // 更新消息总数
  }
  if (newValue.length === 0) {
    console.log(111);
    meaasgeTitle_list.value.forEach((e) => {
      e.value = 0;
    });
    messageCount.value = 0;
    meaasgeTitle_list_xttz.value.forEach((e) => {
      e.status = 1;
    });
  }
}

// 在页面卸载前保存 messageCount 的值到本地存储
window.addEventListener("beforeunload", () => {
  localStorage.setItem("messageCount", messageCount.value.toString());
});

return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meaasgeTitle_list.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(item.checked == true
              ? 'meaasgeTitle_listClickY'
              : 'meaasgeTitle_listClickN'
              ),
                key: index
              }, [
                _createVNode(_component_el_badge, {
                  onClick: ($event: any) => (meaasgeTitleNavClick(index, item)),
                  value: item.value,
                  max: item.value,
                  class: "item",
                  hidden: item.value == 0
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: item.img,
                      alt: ""
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 2
                }, 1032, ["onClick", "value", "max", "hidden"]),
                _createElementVNode("p", null, _toDisplayString(item.title), 1),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "meaasgeTitle_listClickY_select meaasgeTitle_listClickY_selectNo" }, null, -1))
              ], 2))
            }), 128))
          ]),
          _createElementVNode("div", {
            class: "",
            onClick: HRU_list_qbyd,
            style: {"width":"120px","height":"40px","background":"#ffffff","text-align":"center","line-height":"40px","border-radius":"12px","color":"#2978ff","display":"flex","column-gap":"5px","align-items":"center","justify-content":"center","cursor":"pointer"}
          }, _cache[11] || (_cache[11] = [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                style: {"width":"15px","height":"15px","vertical-align":"sub"},
                srcset: ""
              })
            ], -1),
            _createElementVNode("div", null, [
              _createElementVNode("span", null, "全部已读")
            ], -1)
          ]))
        ]),
        (meaasgeTitleNavNumber.value === 'xttz')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (meaasgeTitle_list_xttz.value.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(meaasgeTitle_list_xttz.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "message-item"
                    }, [
                      _createElementVNode("img", {
                        class: "MT_dz_list_imgUser",
                        src: item.avatar1 ? item.avatar1 : require(`@/assets/Frame33.png`)
              
                      }, null, 8, _hoisted_7),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(item.nickName1
                  ? `${item.nickName1} ${item.createTime}`
                  : `系统通知 ${item.createTime}`), 1),
                        _createElementVNode("p", _hoisted_10, [
                          _createElementVNode("span", {
                            style: _normalizeStyle({ color: item.status == 1 ? '#86909C' : '#3fa4ed' })
                          }, _toDisplayString(item.noticeTitle ? item.noticeTitle : item.noticeContent), 5),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailLinks.value, (link, key) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (key === item.code)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                    _createElementVNode("div", {
                                      onClick: ($event: any) => (goToDetail(link.path, link.query, item)),
                                      style: _normalizeStyle({
                      color: item.status == 1 ? '#86909C' : '#3fa4ed',
                    })
                                    }, " 查看详情 >> ", 12, _hoisted_12)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        ])
                      ])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[12] || (_cache[12] = [
                    _createElementVNode("img", {
                      style: {"position":"absolute","top":"50%","left":"50%","width":"45%","height":"100%","color":"#ccc","transform":"translate(-50%, -50%)"},
                      src: _imports_1
                    }, null, -1),
                    _createElementVNode("span", { style: {"position":"absolute","top":"80%","left":"50%","color":"#ccc","transform":"translate(-50%, -50%)"} }, " 暂无消息 ", -1)
                  ])))
            ]))
          : _createCommentVNode("", true),
        (meaasgeTitleNavNumber.value == 'dz')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (meaasgeTitle_list_dz.value.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(meaasgeTitle_list_dz.value, (index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            class: "MT_dz_list_imgUser",
                            src: index.avatar ? index.avatar : require('@/assets/logo.png')
                  ,
                            alt: ""
                          }, null, 8, _hoisted_16),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_17, [
                              _createTextVNode(_toDisplayString(index.nickName) + " ", 1),
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(com_date).com_date.timestamp_string(
                          index.createTime,
                          true,
                          "-",
                          ":"
                        )), 1)
                            ]),
                            _createElementVNode("p", _hoisted_19, _toDisplayString(index.noticeContent), 1)
                          ])
                        ]),
                        _createElementVNode("img", {
                          class: "MT_dz_list_imgWorks",
                          src: JSON.parse(index.extendsData).showImage
                ? JSON.parse(index.extendsData).showImage
                : JSON.parse(index.extendsData).coverSheet
                
                        }, null, 8, _hoisted_20)
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, _cache[13] || (_cache[13] = [
                      _createElementVNode("img", {
                        style: {"position":"absolute","top":"50%","left":"50%","width":"45%","height":"100%","color":"#ccc","transform":"translate(-50%, -50%)"},
                        src: _imports_1
                      }, null, -1),
                      _createElementVNode("span", { style: {"position":"absolute","top":"80%","left":"50%","color":"#ccc","transform":"translate(-50%, -50%)"} }, " 暂无消息 ", -1)
                    ])))
              ])
            ]))
          : _createCommentVNode("", true),
        (meaasgeTitleNavNumber.value == 'sc')
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                (meaasgeTitle_list_dz.value.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(meaasgeTitle_list_dz.value, (index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            class: "MT_dz_list_imgUser",
                            src: index.avatar ? index.avatar : require('@/assets/logo.png')
                  ,
                            alt: ""
                          }, null, 8, _hoisted_24),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_25, [
                              _createTextVNode(_toDisplayString(index.nickName) + " ", 1),
                              _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(com_date).com_date.timestamp_string(
                          index.createTime,
                          true,
                          "-",
                          ":"
                        )), 1)
                            ]),
                            _createElementVNode("p", _hoisted_27, _toDisplayString(index.noticeContent), 1)
                          ])
                        ]),
                        _createElementVNode("img", {
                          class: "MT_dz_list_imgWorks",
                          style: {"width":"80px","height":"80px","object-fit":"cover","border-radius":"12px"},
                          src: JSON.parse(index.extendsData).showImage
                  ? JSON.parse(index.extendsData).showImage
                  : JSON.parse(index.extendsData).coverSheet
                  
                        }, null, 8, _hoisted_28)
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[14] || (_cache[14] = [
                      _createElementVNode("img", {
                        style: {"position":"absolute","top":"50%","left":"50%","width":"45%","height":"100%","color":"#ccc","transform":"translate(-50%, -50%)"},
                        src: _imports_1
                      }, null, -1),
                      _createElementVNode("span", { style: {"position":"absolute","top":"80%","left":"50%","color":"#ccc","transform":"translate(-50%, -50%)"} }, " 暂无消息 ", -1)
                    ])))
              ])
            ]))
          : _createCommentVNode("", true),
        (meaasgeTitleNavNumber.value == 'fs')
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                (meaasgeTitle_list_sc.value.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(meaasgeTitle_list_sc.value, (index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            class: "MT_dz_list_imgUser",
                            src: index.avatar ? index.avatar : require('@/assets/logo.png')
                  ,
                            alt: ""
                          }, null, 8, _hoisted_32),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_33, [
                              _createTextVNode(_toDisplayString(index.memberName) + " ", 1),
                              _createElementVNode("span", _hoisted_34, _toDisplayString(index.followTime), 1)
                            ]),
                            _cache[15] || (_cache[15] = _createElementVNode("p", {
                              class: "MT_dz_list_z",
                              style: {"font-size":"0.12rem","color":"#86909c"}
                            }, " 关注了你 ", -1))
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            class: "MTFS_list_gz",
                            onClick: ($event: any) => (composer(index))
                          }, " 进入主页 ", 8, _hoisted_35)
                        ])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_36, _cache[16] || (_cache[16] = [
                      _createElementVNode("img", {
                        style: {"position":"absolute","top":"50%","left":"50%","width":"45%","height":"100%","color":"#ccc","transform":"translate(-50%, -50%)"},
                        src: _imports_1
                      }, null, -1),
                      _createElementVNode("span", { style: {"position":"absolute","top":"80%","left":"50%","color":"#ccc","transform":"translate(-50%, -50%)"} }, " 暂无消息 ", -1)
                    ])))
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("strong", null, null, -1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_el_pagination, {
            "current-page": _unref(page).pageNum,
            "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_unref(page).pageNum) = $event)),
            "page-size": _unref(page).pageSize,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_unref(page).pageSize) = $event)),
            onSizeChange: _ctx.sizeChange,
            onCurrentChange: currentChange,
            style: {"margin":"0.4rem 0"},
            background: "",
            layout: "prev, pager, next",
            total: _unref(page).total
          }, null, 8, ["current-page", "page-size", "onSizeChange", "total"])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "",
      "show-close": false,
      modelValue: _unref(payment),
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(payment) ? (payment).value = $event : payment = $event)),
      "align-center": "",
      width: "4.8rem",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _cache[18] || (_cache[18] = _createElementVNode("span", null, "联系合作", -1)),
            _createElementVNode("img", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(payment) //@ts-ignore
 ? payment.value = false : payment = false)),
              class: "cur",
              src: _imports_2
            })
          ]),
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "zf_body_title" }, "支付相应费用，获得联系方式", -1)),
          _createElementVNode("div", _hoisted_40, [
            _cache[20] || (_cache[20] = _createElementVNode("span", { CLASS: "zf_b_M_title" }, "应付金额：", -1)),
            _createElementVNode("span", _hoisted_41, [
              _cache[19] || (_cache[19] = _createElementVNode("text", { class: "zf_b_M_n_icon" }, "￥", -1)),
              _createTextVNode(_toDisplayString((_unref(moenyNumber) / 1).toFixed(2)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "zf_fs_title" }, "选择付款方式", -1)),
            _createElementVNode("div", _hoisted_43, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentTypeList), (index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: ($event: any) => (_unref(paymentTL_click)(index))
                }, [
                  _createElementVNode("img", {
                    class: "zf_fs_logo cur",
                    src: index.img
                  }, null, 8, _hoisted_45),
                  _createElementVNode("span", null, _toDisplayString(index.title), 1),
                  (index.checked)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_46))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_44))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", {
              class: "zf_fs_b_qx cur",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(payment) //@ts-ignore
 ? payment.value = false : payment = false))
            }, "取消"),
            _createElementVNode("div", {
              class: "zf_fs_b_qd cur",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(get_sjh)(_unref(obj))))
            }, "确定")
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(TwoDimensionalCode, {
      ref_key: "TwoDimensionalCodeRef",
      ref: TwoDimensionalCodeRef,
      CloseQrCode: CloseQrCode
    }, null, 512),
    _createVNode(_component_el_dialog, {
      modelValue: PartnersMobileNumber.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((PartnersMobileNumber).value = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[23] || (_cache[23] = _createElementVNode("div", { style: {"text-align":"center"} }, "联系方式", -1)),
        _createElementVNode("div", _hoisted_48, _toDisplayString(PartnersMobileNumber1.value), 1),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (PartnersMobileNumber.value = false))
          }, " 取消 "),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (PartnersMobileNumber.value = false))
          }, " 确认 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(show),
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(show) ? (show).value = $event : show = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false,
      title: "系统通知"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(showTitle) ? _unref(showTitle) : "系统通知"), 1),
        _createElementVNode("div", {
          innerHTML: _unref(showHtml),
          style: {"text-align":"center","padding-top":"5px","font-size":"14px"}
        }, null, 8, _hoisted_51)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(DetailsOfWorks, {
      ref_key: "DetailsOfWorksRef",
      ref: DetailsOfWorksRef,
      CloseQrCode1: CloseQrCode1
    }, null, 512)
  ]))
}
}

})